document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('feedback-toggle');
  const formContainer = document.getElementById('feedback-form');
  const form = document.getElementById('custom-feedback-form');
  const confirmation = document.getElementById('feedback-confirmation');
  const submitButton = form.querySelector('button[type="submit"]');
  const nameInput = form.querySelector('[name="name"]');
  const emailInput = form.querySelector('[name="email"]');
  const messageInput = form.querySelector('[name="message"]');

  // Function to validate email format
  function isValidEmail(email) {
    // Basic email pattern: has @ and at least one . after @
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  // Function to validate form and enable/disable submit button
  function validateForm() {
    const name = nameInput.value.trim();
    const email = emailInput.value.trim();
    const message = messageInput.value.trim();

    // Validate email format if field has content
    if (email && !isValidEmail(email)) {
      emailInput.classList.add('invalid');
    } else {
      emailInput.classList.remove('invalid');
    }

    // Check all fields are filled and email is valid
    const isValid = name && email && message && isValidEmail(email);

    submitButton.disabled = !isValid;
  }

  // Add validation listeners to all inputs
  nameInput.addEventListener('input', validateForm);
  emailInput.addEventListener('input', validateForm);
  messageInput.addEventListener('input', validateForm);

  // Disable submit button initially
  submitButton.disabled = true;

  toggle.addEventListener('click', () => {
    formContainer.style.display = (formContainer.style.display === 'block') ? 'none' : 'block';
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Disable the form and show "sending" message
    form.querySelector('button[type="submit"]').disabled = true;
    form.querySelector('button[type="submit"]').innerText = 'Sending...';

    const formData = new FormData(form);
    const payload = {
      name: formData.get('name'),
      email: formData.get('email'),
      message: formData.get('message'),
      website: formData.get('website'),
      page: window.location.pathname
    };

    try {
      const res = await fetch('https://v2xx6pkxr3.execute-api.us-east-1.amazonaws.com/prod/feedback', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Feedback-Token': 'purple-monkey-dishwasher'
        },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        form.style.display = 'none';
        confirmation.style.display = 'block';

        // Optional: fire GA event
        if (window.gtag) {
          gtag('event', 'submit_feedback', {
            event_category: 'Feedback',
            event_label: 'Floating Feedback Form',
            page_location: window.location.pathname
          });
        }

        // Auto-hide the confirmation after 3 seconds
        setTimeout(() => {
          confirmation.style.display = 'none';
          formContainer.style.display = 'none';
          form.reset();
          form.querySelector('button[type="submit"]').innerText = 'Send';
          // Re-disable submit button after reset
          validateForm();
        }, 3000);
      } else {
        throw new Error('Non-OK response');
      }
    } catch (err) {
      console.error(err);
      alert('There was a problem sending your feedback. Please try again later.');
      form.querySelector('button[type="submit"]').innerText = 'Send';
      // Re-validate form on error
      validateForm();
    }
  });
});